import axios from "axios";
import authManager from "./authManager";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});
instance.interceptors.request.use((config) => {
  config.params = config.params || {};
  return config;
});
// instance.interceptors.request.use(async (config) => {
// config.params = config.params || {};

// const method = config.method?.toLowerCase();
// const needsCsrf = ["post", "put", "patch", "delete"].includes(method || "");

// if (needsCsrf) {
// const res = await instance.get("/api/csrf-token");
// config.headers["X-CSRF-Token"] = res.data.csrfToken;
// }

// return config;
// });
const ApiInterceptor = () => {
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        if (error.config) {
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    }
  );
  return null;
};
ApiInterceptor();
const apiRequest = {
  login: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor/${v}/login`, body),

  sendOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor/${v}/sendOtp`, body),

  getDashboardData: ({ v = "v1" } = {}) =>
    instance.get(`/api/vendor/${v}/getDashboardData`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),
  editProductImage: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/vendor/${v}/product/productImage/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  updateProductStatus: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/vendor/${v}/product/status-update/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  editProductImage: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/vendor/${v}/product/productImage/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  deleteProduct: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/vendor/${v}/product/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),
  getProfile: ({ v = "v1" } = {}) =>
    instance.get(`/api/vendor/${v}/profile`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  getServerInfo: ({ v = "v1" } = {}) =>
    instance.get(`/api/vendor/${v}/serverInfo`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),
  updateProfile: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/vendor/${v}/updateProfile`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  getProducts: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor/${v}/getProducts`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),
  createProduct: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor/${v}/create-product`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  getMainCategory: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor/${v}/get-main-category`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  getVendorOrders: ({ v = "v1", body } = {}) =>
    instance.get(`/api/vendor/${v}/vendor/orders`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  getVendorManagers: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor/${v}/vendor-managers`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),
  getExcelImportList: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/vendor/${v}/excel-import-list`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    });
  },

  getImportProductsByExcel: ({ v = "v1", id = null, body } = {}) =>
    instance.post(`/api/vendor/${v}/getImportProductsByExcel/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  getGallery: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor/${v}/gallery`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  createGallery: ({ v = "v1", formData = {} } = {}) => {
    return instance.post(`/api/vendor/${v}/gallery/create`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    });
  },

  updateGallery: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/vendor/${v}/gallery/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  deleteGallery: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/vendor/${v}/gallery/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  getVendorCompliance: ({ v = "v1", body } = {}) =>
    instance.post(`/api/vendor/${v}/vendorCompliance`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  createVendorCompliance: ({ v = "v1", formData = {} } = {}) => {
    return instance.post(`/api/vendor/${v}/vendorCompliance/create`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    });
  },

  updateVendorCompliance: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/vendor/${v}/vendorCompliance/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
      },
    }),

  deleteVendorCompliance: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/vendor/${v}/vendorCompliance/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getVendorAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),
};

export default apiRequest;
